import AlgoliaFactory from '../algolia';
import { fetchBingoGames } from '../bingo';
import { fetchGame, gameLaunchModel } from '../game';
import { fetchLiveTables } from '../liveTable';
import { fetchPage } from '../page';
import { startPromotionsFlow } from '../promotions';
import { fetchRecentlyPlayed } from '../recentlyPlayed';
import { getCanonicalUrl } from '../seo';

const commonModel = {
  ...gameLaunchModel,
  fetchGame,
  AlgoliaFactory,
  fetchLiveTables,
  fetchPage,
  startPromotionsFlow,
  fetchRecentlyPlayed,
  getCanonicalUrl,
  fetchBingoGames,
};

export default commonModel;
